// extracted by mini-css-extract-plugin
module.exports = {"input":"FormTextArea_input__cAY6v","wrapper":"FormTextArea_wrapper__YjOIb","outlined":"FormTextArea_outlined__o2kYc"};